// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-StudyList-Documents-module__actions";
var _2 = "webpack-concepts-Extraction-StudyList-Documents-module__delete";
var _3 = "webpack-concepts-Extraction-StudyList-Documents-module__documentContainer";
var _4 = "webpack-concepts-Extraction-StudyList-Documents-module__heading";
var _5 = "webpack-concepts-Extraction-StudyList-Documents-module__icon";
var _6 = "webpack-concepts-Extraction-StudyList-Documents-module__link";
export { _1 as "actions", _2 as "delete", _3 as "documentContainer", _4 as "heading", _5 as "icon", _6 as "link" }
